<script setup>
import { cn } from '@/lib/utils'
import { inject, ref } from 'vue'
import { User } from 'lucide-vue-next'

/**
 * What an avatar shows when there is no picture.
 *
 * A generic person icon, everywhere, with no slot passed. Call sites used to
 * each supply their own initials, in their own colours — teal here, blue in
 * chat, grey in the member list — so the same user wore a different face on
 * every screen. One icon is duller and consistent, and it never has to guess at
 * initials from a single-word name.
 */
const props = defineProps({
  class: { type: String, default: '' },
})

const imageLoadingStatus = inject('imageLoadingStatus', ref('idle'))
</script>

<template>
  <div
    v-if="imageLoadingStatus === 'idle' || imageLoadingStatus === 'error'"
    :class="cn('flex h-full w-full items-center justify-center rounded-full bg-gray-100 text-gray-400', props.class)"
  >
    <slot>
      <User class="size-1/2" />
    </slot>
  </div>
</template>
